<nav>
  <ol class="flex items-center">
    @if (hiddenBreadcrumbs().length) {
      <li>
        <ng-template
          *ngTemplateOutlet="
            menuTemplate() ?? null;
            context: { $implicit: hiddenBreadcrumbs() }
          "
        ></ng-template>
      </li>
      <li>
        <ng-template *ngTemplateOutlet="separatorTemplate() ?? null"></ng-template>
      </li>
    }

    @for (breadcrumb of visibleBreadcrumbs(); track $index; let last = $last) {
      @for (node of nodes(); track $index) {
        <li>
          <ng-template
            *ngTemplateOutlet="
              node.templateRef;
              context: { $implicit: breadcrumb, last: last }
            "
          ></ng-template>
        </li>

        @if (!last) {
          <li>
            <ng-template *ngTemplateOutlet="separatorTemplate() ?? null"></ng-template>
          </li>
        }
      }
    }
  </ol>
</nav>
